module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo8-da82ea51c0d0922559778ed9377fbc55.jpg";